import React, { lazy } from 'react';
import parseLanguages from 'base-shell/lib/utils/locale';

import LayoutContainer from 'layout/LayoutContainer/LayoutContainer';
import locales from './locales';
import { MainRoutes } from 'routes';
import Loading from 'components/Loading';
import ApiProvider from 'providers/Api';
import ShopProvider from 'providers/Shop';
import AuthProvider from 'providers/Auth';
import CartProvider from 'providers/Cart';
import OrderProvider from 'providers/Order';

import { baseRoute, stage } from './const';

const config = {
  containers: {
    LayoutContainer: ({ children, ...props }) => (
      <LayoutContainer {...props}>
        <AuthProvider>
          <ShopProvider
            mock={stage === 'local' ? require('./mock').shop : undefined}
          >
            <OrderProvider>
              <CartProvider>
                <ApiProvider>{children}</ApiProvider>
              </CartProvider>
            </OrderProvider>
          </ShopProvider>
        </AuthProvider>
      </LayoutContainer>
    ),
  },
  components: {
    Loading,
  },
  pwa: {
    useiOSPWAPrompt: true,
    iOSPWAPromptProps: {},
  },
  routes: MainRoutes(baseRoute),
  locale: {
    locales,
    defaultLocale: parseLanguages(['zh-tw'], 'zh-tw'),
    onError: () => {
      // Here we warn the user about translation error
      // console.warn(e)
      return;
    },
  },
  appbar: {
    width: 240,
  },
  theme: {
    defaultThemeID: 'default',
    defaultIsDarkMode: false,
    defaultIsRTL: false, //change this to true for default Right to Left Language support
  },
  pages: {
    PageNotFound: lazy(() => import('../pages/PageNotFound')),
    LandingPage: lazy(() => import('../pages/LandingPage')),
  },
  notistack: {},
};

export default config;
